import { render } from "./VueMonthlyPicker.vue?vue&type=template&id=481c8d9c"
import script from "./VueMonthlyPicker.vue?vue&type=script&lang=js"
export * from "./VueMonthlyPicker.vue?vue&type=script&lang=js"

import "./VueMonthlyPicker.vue?vue&type=style&index=0&id=481c8d9c&lang=less"
script.render = render

export default script